import { QuizQuestion } from '@monoimin/sb-types';

export const uaeGoldenVisaQuizDict = {
  en: {
    title: 'Are You the Perfect Fit for UAE Golden Visa? - Immigrant Invest',
    description:
      'Take our quiz to find out if you qualify for the UAE Golden Visa based on your preferences and eligibility.',
  },
  ru: {
    title: 'ВНЖ в ОАЭ — Immigrant Invest',
    description:
      'Пройдите наш тест, чтобы узнать, соответствуете ли вы требованиям для получения ВНЖ в ОАЭ на основе ваших предпочтений и критериев.',
  },
};
export const uaeGoldenVisaQuizQuestionsEn: QuizQuestion[] = [
  {
    question:
      'Which way of obtaining a UAE Residence Visa is preferable for you?',
    id: 1,
    answers: [
      {
        id: 1,
        text: 'Investments in real estate',
        image: '/images/quiz/house.png',
        correct: true,
      },
      {
        id: 2,
        text: 'Business',
        image: '/images/quiz/briefcase.png',
        correct: false,
      },
      {
        id: 3,
        text: 'Employment or freelance',
        image: '/images/quiz/laptop.png',
        correct: false,
      },
    ],
  },
  {
    question: 'How much are you ready to invest in UAE real estate?',
    id: 2,
    conditionalLogic: {
      question:
        'Which way of obtaining a UAE Residence Visa is preferable for you?',
      answerIds: [1],
    },
    answers: [
      {
        id: 1,
        text: 'Up to $200,000',
        image: '/images/quiz/coins.png',
        correct: false,
      },
      {
        id: 2,
        text: '$200,000—550,000',
        image: '/images/quiz/moneyDeck.png',
        correct: true,
      },
      {
        id: 3,
        text: 'Over $550,000',
        image: '/images/quiz/wallet.png',
        correct: true,
      },
      {
        id: 4,
        text: 'I already own real estate in the UAE',
        image: '/images/quiz/building.png',
        correct: true,
      },
    ],
  },
  {
    question: 'How much are you ready to spend on a UAE Residence Visa?',
    conditionalLogic: {
      question:
        'Which way of obtaining a UAE Residence Visa is preferable for you?',
      answerIds: [2, 3],
    },
    id: 2,
    answers: [
      {
        id: 1,
        text: 'Under $100,000',
        image: '/images/quiz/coins.png',
        correct: false,
      },
      {
        id: 2,
        text: '$100,000—200,000',
        image: '/images/quiz/moneyDeck.png',
        correct: false,
      },
      {
        id: 3,
        text: 'Over $200,000',
        image: '/images/quiz/wallet.png',
        correct: false,
      },
    ],
  },
  {
    question:
      'When are you ready to start with the procedures for getting a UAE Residence Visa?',
    id: 3,
    answers: [
      {
        id: 1,
        correct: true,
        text: 'Now',
        image: '/images/quiz/plane.png',
      },
      {
        id: 2,
        text: 'In 1-3 months',
        image: '/images/quiz/clock.png',
        correct: true,
      },
      {
        id: 3,
        text: 'In 3-6 months',
        image: '/images/quiz/calendar.png',
        correct: true,
      },
      {
        id: 4,
        text: 'In 6+ months',
        image: '/images/quiz/sandtime.png',
        correct: true,
      },
    ],
  },
  {
    question:
      'Do your family members plan to get UAE Residence Visas with you?',
    id: 4,
    answers: [
      {
        id: 1,

        text: 'Yes',
        image: '/images/quiz/family.png',
        correct: true,
      },
      {
        id: 2,
        correct: true,
        text: 'No',
        image: '/images/quiz/person.png',
      },
    ],
  },
  {
    question:
      'Do you have socially dangerous diseases, like HIV or tuberculosis?',
    id: 5,
    answers: [
      {
        id: 1,

        text: 'Yes',
        image: '/images/quiz/virus.png',
        correct: false,
      },
      {
        id: 2,
        correct: true,
        text: 'No',
        image: '/images/quiz/shield.png',
      },
    ],
  },
  {
    question:
      'Can you visit the UAE for 10 days to pass a medical examination, submit biometrics and apply for a Residence Visa?',
    id: 6,
    answers: [
      {
        id: 1,

        text: 'Yes',
        image: '/images/quiz/cyberhead.png',
        correct: true,
      },
      {
        id: 2,
        correct: false,
        text: 'No',
        image: '/images/quiz/x.png',
      },
    ],
  },
];

export const uaeGoldenVisaQuizQuestionsRu: QuizQuestion[] = [
  {
    question: 'Вы — гражданин России или Беларуси?',
    id: 1,
    answers: [
      {
        id: 1,
        text: 'Да',
        image: '/images/quiz/castle.png',
        correct: true,
      },
      {
        id: 2,
        text: 'Нет',
        image: '/images/quiz/globe.png',
        correct: true,
      },
    ],
  },
  {
    question: 'Какой вариант получения ВНЖ в ОАЭ для вас предпочтительный?',
    id: 2,
    answers: [
      {
        id: 1,
        text: 'Инвестиции в недвижимость',
        image: '/images/quiz/house.png',
        correct: true,
      },
      {
        id: 2,
        text: 'Бизнес',
        image: '/images/quiz/briefcase.png',
        correct: false,
      },
      {
        id: 3,
        text: 'Трудоустройство или фриланс',
        image: '/images/quiz/laptop.png',
        correct: false,
      },
    ],
  },
  {
    question: 'Сколько вы готовы инвестировать в недвижимость ОАЭ?',
    id: 3,
    conditionalLogic: {
      question: 'Какой вариант получения ВНЖ в ОАЭ для вас предпочтительный?',
      answerIds: [1],
    },
    answers: [
      {
        id: 1,
        text: 'До 200 000 $',
        image: '/images/quiz/coins.png',
        correct: false,
      },
      {
        id: 2,
        text: 'От 200 000 $ до 550 000 $',
        image: '/images/quiz/moneyDeck.png',
        correct: true,
      },
      {
        id: 3,
        text: 'От 550 000 $',
        image: '/images/quiz/wallet.png',
        correct: true,
      },
      {
        id: 4,
        text: 'Я уже владею недвижимостью в ОАЭ',
        image: '/images/quiz/building.png',
        correct: true,
      },
    ],
  },
  {
    question: 'Сколько вы готовы потратить, чтобы получить ВНЖ в ОАЭ?',
    conditionalLogic: {
      question: 'Какой вариант получения ВНЖ в ОАЭ для вас предпочтительный?',
      answerIds: [2, 3],
    },
    id: 3,
    answers: [
      {
        id: 1,
        text: 'До 100 000 $',
        image: '/images/quiz/coins.png',
        correct: false,
      },
      {
        id: 2,
        text: 'От 100 000 $ до 200 000 $',
        image: '/images/quiz/moneyDeck.png',
        correct: false,
      },
      {
        id: 3,
        text: 'От 200 000 $',
        image: '/images/quiz/wallet.png',
        correct: false,
      },
    ],
  },
  {
    question:
      'Когда вы готовы приступить к подготовке документов и получению ВНЖ в ОАЭ?',
    id: 4,
    answers: [
      {
        id: 1,
        correct: true,
        text: 'Сейчас',
        image: '/images/quiz/plane.png',
      },
      {
        id: 2,
        text: 'Через 1—3 месяца',
        image: '/images/quiz/clock.png',
        correct: true,
      },
      {
        id: 3,
        text: 'Через 3—6 месяцев',
        image: '/images/quiz/calendar.png',
        correct: true,
      },
      {
        id: 4,
        text: 'Более чем через 6 месяцев',
        image: '/images/quiz/sandtime.png',
        correct: true,
      },
    ],
  },
  {
    question: 'Планируете ли вы получить ВНЖ в ОАЭ вместе с семьей?',
    id: 5,
    answers: [
      {
        id: 1,

        text: 'Да',
        image: '/images/quiz/family.png',
        correct: true,
      },
      {
        id: 2,
        correct: true,
        text: 'Нет',
        image: '/images/quiz/person.png',
      },
    ],
  },
  {
    question: 'Имеете ли вы опасные заболевания — ВИЧ, гепатит или туберкулез?',
    id: 6,
    answers: [
      {
        id: 1,

        text: 'Да',
        image: '/images/quiz/virus.png',
        correct: false,
      },
      {
        id: 2,
        correct: true,
        text: 'Нет',
        image: '/images/quiz/shield.png',
      },
    ],
  },
  {
    question:
      'Сможете ли вы приехать в ОАЭ на 10 дней, чтобы пройти медицинское обследование, сдать биометрию и подать документы на ВНЖ?',
    id: 7,
    answers: [
      {
        id: 1,

        text: 'Да',
        image: '/images/quiz/cyberhead.png',
        correct: true,
      },
      {
        id: 2,
        correct: false,
        text: 'Нет',
        image: '/images/quiz/x.png',
      },
    ],
  },
];

export const uaeGoldenVisaQuizQuestionsDe: QuizQuestion[] = [
  {
    question:
      'Welche Methode der Erlangung eines UAE-Aufenthaltsvisums ist für Sie am besten geeignet?',
    id: 1,
    answers: [
      {
        id: 1,
        text: 'Investitionen in Immobilien',
        image: '/images/quiz/house.png',
        correct: true,
      },
      {
        id: 2,
        text: 'Geschäft',
        image: '/images/quiz/briefcase.png',
        correct: false,
      },
      {
        id: 3,
        text: 'Beschäftigung oder freiberuflich',
        image: '/images/quiz/laptop.png',
        correct: false,
      },
    ],
  },
  {
    question:
      'Wie viel sind Sie bereit, in Immobilien in den VAE zu investieren?',
    id: 2,
    conditionalLogic: {
      question:
        'Welche Methode der Erlangung eines UAE-Aufenthaltsvisums ist für Sie am besten geeignet?',
      answerIds: [1],
    },
    answers: [
      {
        id: 1,
        text: 'Bis zu 200.000 $',
        image: '/images/quiz/coins.png',
        correct: false,
      },
      {
        id: 2,
        text: '200.000 $ – 550.000 $',
        image: '/images/quiz/moneyDeck.png',
        correct: true,
      },
      {
        id: 3,
        text: 'Über 550.000 $',
        image: '/images/quiz/wallet.png',
        correct: true,
      },
      {
        id: 4,
        text: 'Ich besitze bereits Immobilien in den VAE',
        image: '/images/quiz/building.png',
        correct: true,
      },
    ],
  },
  {
    question:
      'Wie viel sind Sie bereit, für ein UAE-Aufenthaltsvisum auszugeben?',
    conditionalLogic: {
      question:
        'Welche Methode der Erlangung eines UAE-Aufenthaltsvisums ist für Sie am besten geeignet?',
      answerIds: [2, 3],
    },
    id: 2,
    answers: [
      {
        id: 1,
        text: 'Unter 100.000 $',
        image: '/images/quiz/coins.png',
        correct: false,
      },
      {
        id: 2,
        text: '100.000 $ – 200.000 $',
        image: '/images/quiz/moneyDeck.png',
        correct: false,
      },
      {
        id: 3,
        text: 'Über 200.000 $',
        image: '/images/quiz/wallet.png',
        correct: false,
      },
    ],
  },
  {
    question:
      'Wann sind Sie bereit, mit den Verfahren zur Erlangung eines UAE-Aufenthaltsvisums zu beginnen?',
    id: 3,
    answers: [
      {
        id: 1,
        correct: true,
        text: 'Jetzt',
        image: '/images/quiz/plane.png',
      },
      {
        id: 2,
        text: 'In 1-3 Monaten',
        image: '/images/quiz/clock.png',
        correct: true,
      },
      {
        id: 3,
        text: 'In 3-6 Monaten',
        image: '/images/quiz/calendar.png',
        correct: true,
      },
      {
        id: 4,
        text: 'In mehr als 6 Monaten',
        image: '/images/quiz/sandtime.png',
        correct: true,
      },
    ],
  },
  {
    question:
      'Planen Ihre Familienangehörigen, ebenfalls UAE-Aufenthaltsvisa mit Ihnen zu erhalten?',
    id: 4,
    answers: [
      {
        id: 1,
        text: 'Ja',
        image: '/images/quiz/family.png',
        correct: true,
      },
      {
        id: 2,
        correct: true,
        text: 'Nein',
        image: '/images/quiz/person.png',
      },
    ],
  },
  {
    question:
      'Leiden Sie an sozial gefährlichen Krankheiten wie HIV oder Tuberkulose?',
    id: 5,
    answers: [
      {
        id: 1,
        text: 'Ja',
        image: '/images/quiz/virus.png',
        correct: false,
      },
      {
        id: 2,
        correct: true,
        text: 'Nein',
        image: '/images/quiz/shield.png',
      },
    ],
  },
  {
    question:
      'Können Sie die VAE für 10 Tage besuchen, um eine medizinische Untersuchung zu bestehen, Biometrie abzugeben und ein Aufenthaltsvisum zu beantragen?',
    id: 6,
    answers: [
      {
        id: 1,
        text: 'Ja',
        image: '/images/quiz/cyberhead.png',
        correct: true,
      },
      {
        id: 2,
        correct: false,
        text: 'Nein',
        image: '/images/quiz/x.png',
      },
    ],
  },
];

export const uaeGoldenVisaQuizQuestionsTr: QuizQuestion[] = [
  {
    question:
      'Birleşik Arap Emirlikleri (BAE) İkamet Vizesi almak için sizin için hangi yol daha tercih edilebilir?',
    id: 1,
    answers: [
      {
        id: 1,
        text: 'Gayrimenkul yatırımları',
        image: '/images/quiz/house.png',
        correct: true,
      },
      {
        id: 2,
        text: 'İşletme',
        image: '/images/quiz/briefcase.png',
        correct: false,
      },
      {
        id: 3,
        text: 'Çalışma veya serbest meslek',
        image: '/images/quiz/laptop.png',
        correct: false,
      },
    ],
  },
  {
    question: 'BAE gayrimenkulüne ne kadar yatırım yapmaya hazırsınız?',
    id: 2,
    conditionalLogic: {
      question:
        'Birleşik Arap Emirlikleri (BAE) İkamet Vizesi almak için sizin için hangi yol daha tercih edilebilir?',
      answerIds: [1],
    },
    answers: [
      {
        id: 1,
        text: '200.000$’a kadar',
        image: '/images/quiz/coins.png',
        correct: false,
      },
      {
        id: 2,
        text: '200.000$—550.000$',
        image: '/images/quiz/moneyDeck.png',
        correct: true,
      },
      {
        id: 3,
        text: '550.000$’dan fazla',
        image: '/images/quiz/wallet.png',
        correct: true,
      },
      {
        id: 4,
        text: 'Zaten BAE’de gayrimenkulüm var',
        image: '/images/quiz/building.png',
        correct: true,
      },
    ],
  },
  {
    question: 'BAE İkamet Vizesi için ne kadar harcamaya hazırsınız?',
    conditionalLogic: {
      question:
        'Birleşik Arap Emirlikleri (BAE) İkamet Vizesi almak için sizin için hangi yol daha tercih edilebilir?',
      answerIds: [2, 3],
    },
    id: 2,
    answers: [
      {
        id: 1,
        text: '100.000$’ın altında',
        image: '/images/quiz/coins.png',
        correct: false,
      },
      {
        id: 2,
        text: '100.000$—200.000$',
        image: '/images/quiz/moneyDeck.png',
        correct: false,
      },
      {
        id: 3,
        text: '200.000$’dan fazla',
        image: '/images/quiz/wallet.png',
        correct: false,
      },
    ],
  },
  {
    question:
      'BAE İkamet Vizesi almak için prosedürlere ne zaman başlamaya hazırsınız?',
    id: 3,
    answers: [
      {
        id: 1,
        correct: true,
        text: 'Şimdi',
        image: '/images/quiz/plane.png',
      },
      {
        id: 2,
        text: '1-3 ay içinde',
        image: '/images/quiz/clock.png',
        correct: true,
      },
      {
        id: 3,
        text: '3-6 ay içinde',
        image: '/images/quiz/calendar.png',
        correct: true,
      },
      {
        id: 4,
        text: '6+ ay içinde',
        image: '/images/quiz/sandtime.png',
        correct: true,
      },
    ],
  },
  {
    question:
      'Aile üyeleriniz sizinle birlikte BAE İkamet Vizesi almak istiyor mu?',
    id: 4,
    answers: [
      {
        id: 1,
        text: 'Evet',
        image: '/images/quiz/family.png',
        correct: true,
      },
      {
        id: 2,
        correct: true,
        text: 'Hayır',
        image: '/images/quiz/person.png',
      },
    ],
  },
  {
    question:
      'HIV veya tüberküloz gibi sosyal açıdan tehlikeli hastalıklarınız var mı?',
    id: 5,
    answers: [
      {
        id: 1,
        text: 'Evet',
        image: '/images/quiz/virus.png',
        correct: false,
      },
      {
        id: 2,
        correct: true,
        text: 'Hayır',
        image: '/images/quiz/shield.png',
      },
    ],
  },
  {
    question:
      'BAE’ye 10 günlüğüne gelip sağlık muayenesinden geçip biyometrik verilerinizi teslim etmeye ve İkamet Vizesi başvurusu yapmaya hazır mısınız?',
    id: 6,
    answers: [
      {
        id: 1,
        text: 'Evet',
        image: '/images/quiz/cyberhead.png',
        correct: true,
      },
      {
        id: 2,
        correct: false,
        text: 'Hayır',
        image: '/images/quiz/x.png',
      },
    ],
  },
];

export const uaeGoldenVisaQuizQuestions = {
  en: uaeGoldenVisaQuizQuestionsEn,
  de: uaeGoldenVisaQuizQuestionsDe,
  ru: uaeGoldenVisaQuizQuestionsRu,
  tr: uaeGoldenVisaQuizQuestionsTr,
};
